import http from "services/http";

export interface FlightSale {
  _id: string;
  booking_id: string;
  status: string;
  traveller: string | null;
  to: string;
  dateTime: string;
  airline: string;
  pnr: string;
  pnrDate: string;
  flightPrice: number;
  amountPaid: number;
  profit: number;
  modeOfPayment?: string;
}

export interface RideSale {
  _id: string;
  status: string;
  traveller: string;
  from: string;
  to: string;
  dateTime: string;
  pickupTime: string;
  ridePrice: number;
  amountPaid: number;
  modeOfPayment: string;
  profit: number;
}

export interface SalesSummary {
  flights: {
    totalFlightPrice: number;
    totalAmountPaid: number;
    totalProfit: number;
  };
  rides: {
    totalRidePrice: number;
    totalAmountPaid: number;
    totalProfit: number;
  };
  combined: {
    totalAmountPaid: number;
    totalServicePrice: number;
    totalProfit: number;
  };
}

export interface SalesResponse {
  success: boolean;
  message: string;
  data: {
    summary: SalesSummary;
    flights: {
      data: FlightSale[];
      pagination: {
        page: number;
        limit: number;
        total: number;
        pages: number;
      };
    };
    rides: {
      data: RideSale[];
      pagination: {
        page: number;
        limit: number;
        total: number;
        pages: number;
      };
    };
  };
}

export const getSalesAnalytics = async (
  fromDate: string,
  toDate: string,
): Promise<SalesResponse> => {
  const response = await http.get(
    `/admin/dashboard/sales/analytics/${fromDate}/${toDate}`,
  );
  return response.data;
};
